import { DEFAULT_SIZE_ID } from 'app/models/organization.model';
import { ICartModifier } from 'app/models/cart.model';

export class Helpers{
  static calculatePriceModifier(modifier: ICartModifier, selectedProductSizeId: string | null = DEFAULT_SIZE_ID): number{
    const size = modifier.sizes.find(s => s.id == selectedProductSizeId);

    if (size){
      return size.price;
    }

    // Эта дальнейшая логика получения размера по умолчанию должна быть на сервере
    if (modifier.defaultPrice){
      return modifier.defaultPrice;
    }

    if (modifier.sizes && modifier.sizes.length){
      return modifier.sizes[0].price;
    }

    return 0;
  }
}
